import axios from 'axios';
import {
    loginRequest,
    loginFail, 
    loginSuccess, 
    clearError,
    registerRequest,
    registerSuccess,
    registerFail,
    loadUserRequest,
    loadUserSuccess,
    loadUserFail,
    logoutSuccess,
    logoutFail,
    updateProfileRequest,
    updateProfileSuccess,
    updateProfileFail,
    updatePasswordRequest,
    updatePasswordSuccess,
    updatePasswordFail,
    forgotPasswordRequest,
    forgotPasswordSuccess,
    forgotPasswordFail,
    resetPasswordRequest,
    resetPasswordSuccess,
    resetPasswordFail
} from '../slices/authSlice';
import {
    usersRequest,
    usersSuccess,
    usersFail,
    userRequest,
    userSuccess,
    userFail,
    deleteUserRequest,
    deleteUserSuccess,
    deleteUserFail,
    updateUserRequest,
    updateUserSuccess,
    updateUserFail,
    createUserRequest,
    createUserSuccess,
    createUserFail,
    changePasswordRequest,
    changePasswordSuccess,
    changePasswordFail
} from '../slices/userSlice'


export const login = (email,password)=> async (dispatch) => {
    try{

        dispatch(loginRequest());
        const { data } = await axios.post('/api/v1/login',{email,password})
        dispatch(loginSuccess(data));


    }catch(error){
        dispatch(loginFail(error.response.data.message))
    }
}

export const clearAuthError = dispatch => {
    dispatch(clearError())
}

export const register = (userData)=> async (dispatch) => {
    try{

        dispatch(registerRequest());
        const config ={
            headers:{
                'Content-type':'application/json'
            }
        }
    
        const { data } = await axios.post('/api/v1/register',userData,config)
        dispatch(registerSuccess(data));


    }catch(error){
        dispatch(registerFail(error.response.data.message))
    }
}


export const loadUser =  async (dispatch) => {
    try{

        dispatch(loadUserRequest());
        
        const { data } = await axios.get('/api/v1/myprofile')
        dispatch(loadUserSuccess(data));


    }catch(error){
        dispatch(loadUserFail(error.response.data.message))
    }
}

export const logout =  async (dispatch) => {
    try{

        
        
        await axios.get('/api/v1/logout ')
        dispatch(logoutSuccess());


    }catch(error){
        dispatch(logoutFail)
    }
}


export const updateProfile = (userData)=> async (dispatch) => {
    try{

        dispatch(updateProfileRequest());
        const config ={
            headers:{
                'Content-type':'application/json'
            }
        }
    
        
        const { data } = await axios.put('/api/v1/update',userData,config)
        dispatch(updateProfileSuccess(data));


    }catch(error){
        dispatch(updateProfileFail(error.response.data.message))
    }
}

export const updatePassword = (userData)=> async (dispatch) => {
    try{

        dispatch(updatePasswordRequest());
        const config ={
                headers:{
                    'Content-type':'application/json'
                }
            }
        
        await axios.put('/api/v1/password/change',userData,config)
        dispatch(updatePasswordSuccess());


    }catch(error){
        dispatch(updatePasswordFail(error.response.data.message))
    }
}

export const forgotPassword = (userData)=> async (dispatch) => {
    try{

        dispatch(forgotPasswordRequest());
        const config ={
            headers:{
                'Content-type':'application/json'
            }
        }
    
        const { data } = await axios.post('/api/v1/password/forgot',userData,config)
        dispatch(forgotPasswordSuccess(data));


    }catch(error){
        dispatch(forgotPasswordFail(error.response.data.message))
    }
}

export const resetPassword = (userData,token)=> async (dispatch) => {
    try{

        dispatch(resetPasswordRequest());
        const config ={
            headers:{
                'Content-type':'application/json'
            }
        }
    
        const { data } = await axios.post(`/api/v1/password/reset/${token}`,userData,config)
        dispatch(resetPasswordSuccess(data));


    }catch(error){
        dispatch(resetPasswordFail(error.response.data.message))
    }
}

export const getUsers =  async (dispatch) => {

    try {
        dispatch(usersRequest())
        const { data }  = await axios.get(`/api/v1/admin/users`);
        dispatch(usersSuccess(data))
    } catch (error) {
        dispatch(usersFail(error.response.data.message))
    }

}

export const getUser = id => async (dispatch) => {

    try {
        dispatch(userRequest())
        const { data }  = await axios.get(`/api/v1/admin/user/${id}`);
        dispatch(userSuccess(data))
    } catch (error) {
        dispatch(userFail(error.response.data.message))
    }

}

export const deleteUser = id => async (dispatch) => {

    try {
        dispatch(deleteUserRequest())
        await axios.delete(`/api/v1/admin/user/${id}`);
        dispatch(deleteUserSuccess())
    } catch (error) {
        dispatch(deleteUserFail(error.response.data.message))
    }

}

export const updateUser = (id, formData) => async (dispatch) => {

    try {
        dispatch(updateUserRequest())
        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        await axios.put(`/api/v1/admin/user/${id}`, formData, config);
        dispatch(updateUserSuccess())
    } catch (error) {
        dispatch(updateUserFail(error.response.data.message))
    }

}

export const createNewUser = (userData) => async (dispatch) => {

    try {
        dispatch(createUserRequest())
        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        await axios.post(`/api/v1/admin/user/new`, userData, config);
        dispatch(createUserSuccess())
    } catch (error) {
        dispatch(createUserFail(error.response?.data?.message || 'Failed to create user'))
    }

}

export const changeUserPassword = (id, passwordData) => async (dispatch) => {

    try {
        dispatch(changePasswordRequest())
        const config = {
            headers: {
                'Content-type': 'application/json'
            }
        }
        const { data } = await axios.put(`/api/v1/admin/user/${id}/password`, passwordData, config);
        dispatch(changePasswordSuccess(data))
    } catch (error) {
        dispatch(changePasswordFail(error.response?.data?.message || 'Failed to update password'))
    }

}